import { useI18n } from '@i18n/useI18n';
import { useStore } from '@store/appStore';
import { SortContainer, SortWrapper } from './SortOptionsProjection.styled';
import ArrowDown from '@assets/svg/chevron-down.svg';
import { useEffect, useState } from 'react';
import { useDetectClickOutside } from 'react-detect-click-outside';

interface IProps {
  content?: any;
  setSort?: (any) => any;
  course?: boolean;
  courses: any;
}

export const SortOptionsProjection = (props: IProps) => {
  const { settings } = useStore();
  const i18n = useI18n();
  const [sortType, setSortType] = useState<any>({ coursedisplayname: 'total-absence', coursedescription: '' });
  const [open, setOpen] = useState(false);
  const ClickOutside = () => {
    setOpen(false);
  };
  const ref = useDetectClickOutside({ onTriggered: ClickOutside });

  const updateSort = (s) => {
    setSortType(s);
    props.setSort(s);
    setOpen(false);
  };

  useEffect(() => {
    if (props.courses) {
      let defaultCourse = { coursedisplayname: 'total-absence', coursedescription: '' }
      setSortType(defaultCourse)
      props.setSort(defaultCourse)
    }
  }, [props.courses])

  let courses = [{ coursedisplayname: 'total-absence', coursedescription: '' }];
  if (props.courses) courses = courses.concat(props.courses);

  return (
    <SortWrapper ref={ref} open={open} onClick={() => setOpen(!open)} course={props.course}>
      {sortType.coursedescription ? sortType.coursedisplayname + ' - ' + sortType.coursedescription : i18n.t(sortType.coursedisplayname)}
      <ArrowDown />
      <SortContainer open={open}>
        {courses?.map((s, index) => {
          return (
            <span onClick={() => updateSort(s)} key={s.coursedisplayname + ' - ' + s.coursedescription + '_' + index}>
              {s.coursedescription ? s.coursedisplayname + ' - ' + s.coursedescription : i18n.t(s.coursedisplayname)}
            </span>
          );
        })}
      </SortContainer>
    </SortWrapper>
  );
};

export default SortOptionsProjection;
